<template>
    <section id="mainContainer">
        <userHeader></userHeader>
        <section class="mid-container">
            <section class="page-banner-section"
                :style="{ 'background-image': `url(${require('@/assets/images/about-banner.jpg')})` }">
                <div class="container">
                    <h1>About LMD Consulting</h1>
                </div>
            </section>
            <section class="join-contact-form-section">
                <div class="container">
                    <div class="form-tabs--top">
                        <ul class="nav" id="myTab" role="tablist">
                            <li>
                                <a class="active" id="tab-a" data-bs-toggle="tab" href="#taba" role="tab"
                                    aria-controls="taba" aria-selected="true">Contact Us</a>
                            </li>
                            <li>
                                <a id="tab-b" data-bs-toggle="tab" href="#tabb" role="tab" aria-controls="tabb"
                                    aria-selected="false">Join Our Team</a>
                            </li>
                        </ul>
                    </div>
                    <div class="form-tabs--btm tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="taba" role="tabpanel" aria-labelledby="tab-a">
                            <div class="contact-form">
                                <form @submit.prevent="submitContactUs">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="text" placeholder=" Name" v-model="contactUsForm.name"/>
                                            <div class="error-msg" v-if="contactUsErrors.name">{{ contactUsErrors.name }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="email" placeholder=" Email" v-model="contactUsForm.email"/>
                                            <div class="error-msg" v-if="contactUsErrors.email">{{ contactUsErrors.email }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input-field">
                                            <input type="text" placeholder=" Subject" v-model="contactUsForm.subject"/>
                                            <div class="error-msg" v-if="contactUsErrors.subject">{{ contactUsErrors.subject }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="input-field">
                                            <textarea placeholder=" Message" v-model="contactUsForm.message"></textarea>
                                            <div class="error-msg" v-if="contactUsErrors.message">{{ contactUsErrors.message }}</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="input-submit">
                                            <button class="primary-btn-outline" :disabled="isSubmitting">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
                                            <button type="button" class="primary-btn-outline" @click="resetContactUsForm">Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tabb" role="tabpanel" aria-labelledby="tab-b">
    <form @submit.prevent="submitApplication">
        <div class="joinus-form">
            <div class="row">
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="text" placeholder=" Name" v-model="applicationForm.candidateName" />
                        <div class="error-msg" v-if="applicationErrors.candidateName">{{ applicationErrors.candidateName }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="email" placeholder="Email Address*" v-model="applicationForm.email" />
                        <div class="error-msg" v-if="applicationErrors.email">{{ applicationErrors.email }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <select class="selectbox" v-model="applicationForm.designation">
                            <option value="">Select Job</option>
                            <option v-for="category in jobCategories" :key="category.id" :value="category.title">
                                {{ category.title }}
                            </option>
                        </select>
                        <div class="error-msg" v-if="applicationErrors.designation">{{ applicationErrors.designation }}</div>
                    </div>
                </div>
                <!-- Other fields remain unchanged as they don't need specific error messages -->
                <div class="col-sm-4">
                    <div class="input-field">
                        <input type="text" placeholder="Name of your Reference (if any)"
                            v-model="applicationForm.nameOfReference" />
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <div class="browse-input">
                            <div class="browse-field">
                                <div class="browse-button company-logo">Image</div>
                                <input type="file" @change="handleFileUpload($event)" accept="image/jpeg,image/jpg,image/png" :key="fileInputKey" />
                                
                            </div>
                            <div class="browsed-img" v-if="imageUploaded"><img :src="imageUrl" alt="" /></div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="input-field">
                        <div class="browse-input">
                            <div class="browse-field">
                                <div class="browse-button company-logo">Resume</div>
                                <input type="file" @change="handleResumeUpload($event)" accept=".pdf" :key="fileInputKey" />
                                
                            </div>
                            <div class="browsed-img" v-if="resumeUploaded">{{ ResumeName }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="input-field">
                        <textarea placeholder="Details" v-model="applicationForm.description"></textarea>
                        <div class="error-msg" v-if="!applicationForm.description">{{ errMsg }}</div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="input-submit">
                        <button class="primary-btn-outline" :disabled="isSubmitting">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
                        <button type="button" class="primary-btn-outline" @click="resetForm">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
                    </div>
                </div>
            </section>

            <section class="our-location-section">
                <div class="container">
                    <h2>Our Locations</h2>
                    <div class="location-map">
                        <img src="@/assets/images/map.png" alt="world-map" class="world-map" />
                        <div class="address-bg usa">
                            <div class="address">
                                <ul>
                                    <li><i class="fa fa-home"></i> <span>21515 Ridgetop Circle Suite 150 Sterling, VA
                                            20166</span></li>
                                    <li><i class="fa fa-phone"></i> <span>+1 571-313-8814</span></li>
                                    <li><i class="fa fa-envelope"></i> <span><a
                                                href="mailto:hello@lmdconsulting.com">hello@lmdconsulting.com</a></span>
                                    </li>
                                </ul>
                                <img src="@/assets/images/location-icon.png" class="map-icon">
                            </div>
                        </div>

                        <div class="address-bg india">
                            <div class="address">
                                <ul>
                                    <li><i class="fa fa-home"></i> <span>2nd Floor, Plot No. B-2/19, Gandhipath,
                                            Chitrakoot, Jaipur, Rajasthan 302021</span></li>
                                    <li><i class="fa fa-phone"></i> <span>+91 141-491-5291</span></li>
                                    <li><i class="fa fa-envelope"></i> <span><a
                                                href="mailto:hello@lmdconsulting.com">hello@lmdconsulting.com</a></span>
                                    </li>
                                </ul>
                                <img src="@/assets/images/location-icon.png" class="map-icon">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <userFooter></userFooter>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import userFooter from "@/components/userFooter.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '@/config/api.config';

interface ApplicationForm {
    candidateName: string;
    email: string;
    designation: string;
    nameOfReference: string;
    candidateImage: string | null;
    candidateResume: File | null;
    description: string;
}

interface ContactUsForm {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export default defineComponent({
    name: "About-Us",
    components: {
        userHeader,
        userFooter
    },
    data() {
        return {

            applicationForm: {
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: '',
                candidateImage: null,
                candidateResume: null,
                description: ''
            } as ApplicationForm,
            jobCategories: [] as any,
            imageSrc: '',
            selectedImageFile: null as File | null,
            imageUploaded: false,
            selectedResumeFile: null as File | null,
            errMsg: '',
            ResumeName: '',
            resumeUploaded: false,
            fileInputKey: 0,
            contactUsForm:{
                name: '',
                email: '',
                subject: '',
                message: ''
            } as ContactUsForm,
            contactUsErrors: {
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                }, // Replace errContactUsMsg with this

            // Add this for Join Our Team form errors
          applicationErrors: {
            candidateName: '',
            email: '',
            designation: '',
        },
        isSubmitting: false // Add this to track submission state
    };
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
    },
    created() {
        this.getJobCategories();
    },
    methods: {
        async submitApplication() {
    // Prevent submission if already submitting
    if (this.isSubmitting) return;

    // Set submitting state
    this.isSubmitting = true;

    // Clear previous errors
    this.applicationErrors = {
        candidateName: '',
        email: '',
        designation: ''
    };
    this.errMsg = '';

    let hasErrors = false;

    // Validate specific fields
    if (!this.applicationForm.candidateName) {
        this.applicationErrors.candidateName = 'Please enter a name';
        hasErrors = true;
    }
    if (!this.applicationForm.email) {
        this.applicationErrors.email = 'Please enter an email';
        hasErrors = true;
    } else if (!this.isValidEmail(this.applicationForm.email)) {
        this.applicationErrors.email = 'Please enter a valid email address';
        hasErrors = true;
    }
    if (!this.applicationForm.designation) {
        this.applicationErrors.designation = 'Please select a job';
        hasErrors = true;
    }

    // // Validate other fields with generic error message
    // if (!this.applicationForm.description || !this.selectedImageFile || !this.selectedResumeFile) {
    //     this.errMsg = 'All fields are required';
    //     hasErrors = true;
    // }

    // If there are errors, stop here and reset submitting state
    if (hasErrors) {
        this.isSubmitting = false;
        return;
    }

    const formData = new FormData();
    formData.append('candidateName', this.applicationForm.candidateName);
    formData.append('email', this.applicationForm.email);
    formData.append('designation', this.applicationForm.designation);
    formData.append('nameOfReference', this.applicationForm.nameOfReference);
    formData.append('description', this.applicationForm.description);
    if (this.selectedImageFile) {
        formData.append('candidateImage', this.selectedImageFile);
    }
    if (this.selectedResumeFile) {
        formData.append('candidateResume', this.selectedResumeFile);
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/candidates/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        this.resetForm();
        this.imageUploaded = false;
        this.resumeUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Form Submitted Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.log(error);
        Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'An error occurred while submitting the form. Please try again.',
            showConfirmButton: true
        });
    } finally {
        // Reset submitting state
        this.isSubmitting = false;
    }
},
resetForm() {
    this.applicationForm = {
        candidateName: '',
        email: '',
        designation: '',
        nameOfReference: '',
        candidateImage: null,
        candidateResume: null,
        description: ''
    };
    this.selectedImageFile = null;
    this.selectedResumeFile = null;
    this.imageSrc = '';
    this.errMsg = '';
    this.imageUploaded = false;
    this.resumeUploaded = false;
    this.ResumeName = '';
    this.fileInputKey++;
    // Clear application errors
    this.applicationErrors = {
        candidateName: '',
        email: '',
        designation: ''
    };
    this.isSubmitting = false;
},
        async getJobCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/jobcategory/?status=1`);
                this.jobCategories = response.data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        handleFileUpload(event: any) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        this.imageSrc = e.target.result;
                        this.selectedImageFile = file;
                        this.imageUploaded = true

                    }
                };
            }
        },

        isValidEmail(email: string): boolean {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        handleResumeUpload(event: Event) {
            const target = event.target as HTMLInputElement;
            const file = target.files?.[0];
            if (file) {
                this.selectedResumeFile = file;
                this.ResumeName = this.selectedResumeFile.name;
                this.resumeUploaded = true;
            }
        },
        async submitContactUs(){
            // Clear previous errors
        this.contactUsErrors = {
            name: '',
            email: '',
            subject: '',
            message: ''
        };

        let hasErrors = false;

        // Validate each field
        if (!this.contactUsForm.name) {
            this.contactUsErrors.name = 'Please enter a name';
            hasErrors = true;
        }
        if (!this.contactUsForm.email) {
            this.contactUsErrors.email = 'Please enter an email';
            hasErrors = true;
        } else if (!this.isValidEmail(this.contactUsForm.email)) {
            this.contactUsErrors.email = 'Please enter a valid email address';
            hasErrors = true;
        }
        if (!this.contactUsForm.subject) {
            this.contactUsErrors.subject = 'Please enter a subject';
            hasErrors = true;
        }
        if (!this.contactUsForm.message) {
            this.contactUsErrors.message = 'Please enter a message';
            hasErrors = true;
        }

        // If there are errors, stop here
        if (hasErrors) {
            return;
        }
            const formData = new FormData();
            formData.append('name', this.contactUsForm.name);
            formData.append('email', this.contactUsForm.email);
            formData.append('subject', this.contactUsForm.subject);
            formData.append('message', this.contactUsForm.message);
            try {
                const response = await axios.post(`${API_BASE_URL}/contactus/`,formData)
                this.resetContactUsForm()
                Swal.fire({
                    icon: 'success',
                    title: 'Form Submitted Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error) {
                console.error(Error)
            }
        },
        resetContactUsForm() {
            this.contactUsForm = {
                name: '',
                email: '',
                subject: '',
                message: ''
            };
            this.contactUsErrors = {
                name: '',
                email: '',
                subject: '',
                message: ''
            };
        },
    }
});
</script>